/* <wg-recently-viewed>: lightweight recently-viewed products.
   Stores product handles in localStorage on product pages, renders up to 4 cards,
   hides the whole section when fewer than 2 valid products exist. */
(function () {
  if (customElements.get('wg-recently-viewed')) return;

  var STORAGE_KEY = 'wg:recently-viewed';
  var MAX_STORED = 8;

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];
    }
  }

  function writeStored(list) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (e) {
      /* storage unavailable — fail silently */
    }
  }

  function formatMoney(cents, format) {
    var amount = cents / 100;
    var hasDecimals = Math.round(cents) % 100 !== 0;
    var value = amount.toLocaleString(undefined, {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2,
    });
    return (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  class WGRecentlyViewed extends HTMLElement {
    connectedCallback() {
      var currentHandle = this.getAttribute('data-current-handle');
      var limit = Math.min(parseInt(this.getAttribute('data-limit'), 10) || 4, 4);
      var moneyFormat = this.getAttribute('data-money-format') || '{{amount}}';
      var stored = readStored();

      var toRender = stored.filter(function (h) { return h !== currentHandle; }).slice(0, limit);

      if (currentHandle) {
        var next = [currentHandle].concat(stored.filter(function (h) { return h !== currentHandle; }));
        writeStored(next);
      }

      if (toRender.length < 2) return;

      var self = this;
      Promise.all(
        toRender.map(function (handle) {
          return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'products/' + handle + '.js' : '/products/' + handle + '.js')
            .then(function (res) { return res.ok ? res.json() : null; })
            .catch(function () { return null; });
        })
      ).then(function (products) {
        var valid = products.filter(function (p) { return p && p.title; });
        if (valid.length < 2) return;

        var list = self.querySelector('[data-wg-rv-list]');
        if (!list) return;

        var boxed = self.getAttribute('data-card-style') === 'card';
        var cardScheme = self.getAttribute('data-card-scheme') || '';
        var showDesc = self.getAttribute('data-show-description') === 'true';
        var descWords = parseInt(self.getAttribute('data-description-words'), 10) || 14;

        valid.forEach(function (p) {
          var li = document.createElement('li');
          var outer = document.createElement('div');
          outer.className = 'wg-pc-outer';
          outer.style.setProperty('--wg-pc-outer-bg', 'rgb(var(--color-background))');

          var article = document.createElement('article');
          article.className = 'wg-pc wg-pc--classic wg-pc--' + (boxed ? 'card' : 'standard') + (boxed && cardScheme ? ' color-' + cardScheme + ' gradient' : '');

          var media = document.createElement('div');
          media.className = 'wg-pc__media wg-media wg-media--zoom';
          if (p.featured_image) {
            var img = document.createElement('img');
            img.className = 'wg-pc__img';
            img.loading = 'lazy';
            img.src = p.featured_image + (p.featured_image.indexOf('?') === -1 ? '?width=600' : '&width=600');
            img.alt = p.title;
            img.width = 600;
            img.height = 600;
            media.appendChild(img);
          }

          var body = document.createElement('div');
          body.className = 'wg-pc__body';

          var head = document.createElement('div');
          head.className = 'wg-pc__head';
          var headText = document.createElement('div');
          headText.className = 'wg-pc__head-text';

          if (p.vendor) {
            var vendor = document.createElement('span');
            vendor.className = 'wg-pc__vendor';
            vendor.textContent = p.vendor;
            headText.appendChild(vendor);
          }

          var title = document.createElement('h3');
          title.className = 'wg-pc__title';
          var link = document.createElement('a');
          link.className = 'wg-pc__link';
          link.href = p.url;
          link.textContent = p.title;
          title.appendChild(link);
          headText.appendChild(title);
          head.appendChild(headText);
          body.appendChild(head);

          if (showDesc && p.description) {
            var tmp = document.createElement('div');
            tmp.innerHTML = p.description;
            var words = (tmp.textContent || '').replace(/\s+/g, ' ').trim().split(' ');
            if (words[0]) {
              var desc = document.createElement('p');
              desc.className = 'wg-pc__desc';
              desc.textContent = words.slice(0, descWords).join(' ') + (words.length > descWords ? '…' : '');
              body.appendChild(desc);
            }
          }

          var foot = document.createElement('div');
          foot.className = 'wg-pc__foot';
          var price = document.createElement('div');
          price.className = 'wg-pc__price';
          var priceText = document.createElement('span');
          priceText.className = 'price';
          priceText.textContent = formatMoney(p.price, moneyFormat);
          price.appendChild(priceText);
          foot.appendChild(price);
          body.appendChild(foot);

          article.appendChild(media);
          article.appendChild(body);
          outer.appendChild(article);
          li.appendChild(outer);
          list.appendChild(li);
        });

        self.removeAttribute('hidden');
      });
    }
  }

  customElements.define('wg-recently-viewed', WGRecentlyViewed);
})();
